export default "__VITE_ASSET__DaEE0uyu__"